{
	"releases": [
		{
			"version": "2.40.0",
			"date": "2026-05-11",
			"sections": [
				{
					"heading": "Form Enhancements",
					"items": [
						"New Anchor subform type: Users can better structure their data with a dedicated Anchor subform that uses the Accurate Anchor field instead of a basic Vector field. Available in Base Form and PLA forms moving forward; existing forms of these types can be updated to include it.",
						"Operating Company in IKE PoleForeman Form Name: Forms generated from a database connection in IKE Office Pro will display the selected Operating Company in the form name. If the database has only one Operating Company, the form name defaults to the Organization name."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Locked fields are now protected: Locked fields in Base Form and PLA forms can no longer be edited, preventing accidental deletion of required data and improving export reliability.",
						"Clearer Excel export error messages: Exports that fail due to unsupported characters now surface a clear error message. This applies to both the general Excel export and the Importable Excel export.",
						"DDS altitude export corrected: Distribution Design Studio (DDS) exports from IKE Office Pro now correctly export altitude (elevation) data in feet instead of meters.",
						"Behind-the-scenes improvements and maintenance."
					]
				}
			]
		},
		{
			"version": "2.39.1",
			"date": "2026-04-23",
			"description": "Hotfix: resolved reported issues with PLA export validation. Warnings and errors for PLA exports should now be appearing as expected for end users."
		},
		{
			"version": "2.39.0",
			"date": "2026-04-21",
			"sections": [
				{
					"heading": "Form Management",
					"items": [
						"IPF Refresh Form Improvements: Custom field positions and selection options (Owners, metadata, etc.) are now retained when using the Refresh Form tool on IKE PoleForeman forms. No more manual reordering after a refresh.",
						"Form Archive: Admin and Data Admin users in IKE Office Pro can now archive forms instead of deleting them. Archived forms appear at the bottom of the Forms page, can be restored at any time, and won't be available in IKE Field or for data import. Existing collections on archived forms remain functional."
					]
				},
				{
					"heading": "OCalc PLA Improvements",
					"items": [
						"Non-Wood Pole Type Refinements: Steel, composite, and other non-wood pole types now appear in a more structured nested list on OCalc form creation, grouped by Material, Class, and Height (more consistent with existing conventions).",
						"OCalc Form Upload Validation: IKE Office now validates lccfg files on import, surfacing errors and warnings in the same format previously provided by ikebot."
					]
				},
				{
					"heading": "Map Enhancements",
					"items": [
						"Persistent Map Settings: Selected map settings (Map or Satellite) now persist across view switches, page refreshes, and department changes in both the Big Map view and PhotoMeasure Map inset. Note: Satellite remains the default when opening a job in Map Based Review Mode.",
						"Measure Tool in Map Based Review Mode: New point-to-point distance and bearing measurement tool in Map Based Review Mode. Works between collections or any two selected locations on the map. Quick A-to-B only, not cumulative."
					]
				},
				{
					"heading": "Excel Import Improvements",
					"items": [
						"Multi-Job Import via Zip File: IKE Office Pro users can now upload a zip containing multiple Excel files to create or update multiple jobs in one go. Validation is surfaced at the job level. File size limit has also been increased to support files over 100KB."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Collections no longer freeze when span information related to an Accurate Anchor field is deleted from the form.",
						"Assign functionality now matches on email address OR first/last name, fixing cases where users couldn't be found.",
						"Base Form label updates - Low Power Attachment field is now self-titled; Attachment Height Label in the Make Ready Subform now includes the attachment size."
					]
				},
				{
					"heading": "Backend",
					"items": ["Automated pipeline test results are now accessible to QA in Jira for better testing alignment."]
				}
			]
		},
		{
			"version": "2.38.0",
			"date": "2026-03-29",
			"sections": [
				{
					"heading": "Form Enhancements",
					"items": [
						"Span Linking: new functionality within Span type subforms that combines collection linking with the 'copy from existing span' tool to automatically create a two-way link between poles. Existing unlinked spans can be chosen via a new modal",
						"Span Subform for Current Custom Forms: users with custom forms can now update their forms to include the Span Subform type, improving data integrity and enabling access to Span Linking"
					]
				},
				{
					"heading": "Map Enhancements",
					"items": [
						"View Imported (not collected) Collections: jobs and collections now display a red dot in list and map views if they have not been collected in the field, making it easier to differentiate pre-loaded data from field-collected data"
					]
				},
				{
					"heading": "IPF Integration Improvements",
					"items": [
						"Improved Export Reliability (Timeout Fix): IPF and other exports now work regardless of the number of collections. A new export manager UI is available behind a department token for additional feedback",
						"Secondary Multiplex Conductor Support: IKE Office now properly validates and exports Secondary Multiplex cables to IPF",
						"Validation Error Improvements: the 'Unknown in Unknown is missing' error should no longer appear for missing down guy info and other fields"
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Location Photos for Target location captures are now retained when editing collections using the importable Excel",
						"Image Zip Export now provides only a single composite image for each annotated IKEphoto",
						"Resolved endpoint issue that occasionally caused image uploads to be blocked from IKE Field",
						"Improved backend security validation for IKE Field APK"
					]
				}
			]
		},
		{
			"version": "2.37.0",
			"date": "2026-02-23",
			"sections": [
				{
					"heading": "Form Enhancements",
					"items": [
						"Base Form: all IKE Office users now have access to a Base Form template in Form Builder. Critical data collected on the Base Form can also be migrated to PLA forms",
						"Non-Wood Pole Material Support (OCalc): OCalc PLA users can now import and select non-wood pole materials (e.g. steel) in their collection forms",
						"Increased File Upload Limit: the file upload tool now supports files up to 10MB (previously 4MB)"
					]
				},
				{
					"heading": "Map Enhancements",
					"items": [
						"Create Collections in Map-Based Review Mode: a new button in the Map toolbar lets users select a location directly on the map to create a new collection",
						"Ruling Span Tool in Map-Based Review Mode: a new Ruling Span tool lets users measure cumulative distance and calculate Ruling Span between selected locations",
						"Annotations Visible on IKEphotos: annotations now display on IKEphotos within the photo carousel in Map-Based Review Mode"
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Fixed an issue where collections with Vertical Separation measurements could not be selected within a job after Form Migration",
						"Resolved an issue where the 'Address' and 'Map Color' form metadata fields were not activating within Base Form for IO Pro users",
						"Backend performance improvements for antivirus scanning"
					]
				}
			]
		},
		{
			"version": "2.36.2",
			"date": "2026-01-29",
			"description": "Hotfix: resolved an issue with the 'copy from existing span' tool on IPF collection forms. All circuit information now copies over as expected"
		},
		{
			"version": "2.36.1",
			"date": "2026-01-27",
			"description": "Hotfix: fixed an issue with the Excel import tool that was intermittently causing failed imports. Excel files now import more reliably"
		},
		{
			"version": "2.36.0",
			"date": "2026-01-22",
			"sections": [
				{
					"heading": "Form Management",
					"items": [
						"Custom form tool for IPF (s-form): users who can create IPF forms via database connection can now select an existing form to duplicate its custom fields within new form creation"
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Fixed an issue where collections with deleted drawables linked to form fields couldn't be uploaded from IKE Field",
						"Corrected form thumbnail dimensions in Office",
						"Resolved edge case with height markers that was causing Office to crash while using the copy from existing span tool",
						"Improved error handling for Pukeko (PolePilot) to reduce 5xx errors",
						"Fixed DDS issue where 2x secondary standard components were incorrectly merged into one",
						"Prevented assigning the same anchor as its own reference (Accurate Anchor tool)"
					]
				},
				{
					"heading": "Infrastructure / Tech Debt",
					"items": [
						"Investigated MongoDB/document DB version update",
						"Migrated IKE Office test environment to the Spikeless DB cluster"
					]
				},
				{
					"heading": "Support for IKE Field",
					"items": [
						"Addressed zoom issue where photos from Orca devices do not retain zoom level in Office (full support lands in next IKE Field release)"
					]
				}
			]
		}
	]
}
